import { queryFilter } from 'utils/proptypes';
import base from './baseApi';

const { urls, methods, execute } = base();

export type ActivityLogParams = queryFilter & {
   organizationId?: string;
   fromDate?: string;
   toDate?: string;
};

export const getActivityLogs = (params?: queryFilter & ActivityLogParams) => {
   const header = {
      authorization: true,
   };

   const method = methods.GET;
   const url = `${urls.activityLog.getAll}`;
   const response = execute(method, url, header, params);

   return response;
};

export const downloadActivityLogsFile = async (params?: ActivityLogParams) => {
   const { fromDate, toDate } = params || {};

   const header = {
      authorization: true,
   };
   const method = methods.GET;
   const url = `${urls.activityLog.export}`;

   const response = await execute(method, url, header, params, undefined, undefined, 'blob');

   // Generate file name
   let fileName = 'activity-logs-all.xlsx';

   if (fromDate && toDate) {
      fileName = `activity-logs (${fromDate}-to-${toDate}).xlsx`;
   }

   // convert blob to download link and open it
   const urlDownloadFile = window.URL.createObjectURL(new Blob([response.data]));
   const link = document.createElement('a');
   link.href = urlDownloadFile;
   link.setAttribute('download', fileName);
   document.body.appendChild(link);
   link.click();
   document.body.removeChild(link);
};
